export const CONTENT_LOCALES = [
  { value: 'zh-Hans', short: '简', label: '简体中文' },
  { value: 'zh-Hant', short: '繁', label: '繁體中文' },
  { value: 'en', short: 'EN', label: 'English' }
]

const ALLOWED_LOCALES = new Set(CONTENT_LOCALES.map(item => item.value))
let traditionalConverterPromise

async function getTraditionalConverter() {
  if (!traditionalConverterPromise) {
    traditionalConverterPromise = import('opencc-js/dist/esm/cn2t.js').then(module => {
      const OpenCC = module.default || module
      return OpenCC.Converter({ from: 'cn', to: 'tw' })
    })
  }
  return traditionalConverterPromise
}

export function localizedFieldName(baseField, locale) {
  if (locale === 'zh-Hant') return `${baseField}ZhHant`
  if (locale === 'en') return `${baseField}En`
  return baseField
}

export function getLocalizedValue(source, baseField, locale) {
  if (!source) return ''
  return source[localizedFieldName(baseField, locale)] || ''
}

export function setLocalizedValue(vm, target, baseField, locale, value) {
  vm.$set(target, localizedFieldName(baseField, locale), value)
}

export async function generateTraditionalDraft(vm, target, baseFields) {
  const toTraditional = await getTraditionalConverter()
  let changed = false
  baseFields.forEach(baseField => {
    const source = String(target[baseField] || '').trim()
    if (!source) return
    vm.$set(target, `${baseField}ZhHant`, toTraditional(source))
    changed = true
  })
  return changed
}

export function normalizePublishedLocales(locales, defaultLocale = 'zh-Hans') {
  const normalized = Array.isArray(locales)
    ? locales.filter(locale => ALLOWED_LOCALES.has(locale))
    : []
  const result = [...new Set(normalized)]
  if (!result.includes(defaultLocale)) result.unshift(defaultLocale)
  return CONTENT_LOCALES.map(item => item.value).filter(locale => result.includes(locale))
}

export function parsePublishedLocales(value, defaultLocale = 'zh-Hans') {
  if (Array.isArray(value)) return normalizePublishedLocales(value, defaultLocale)
  if (typeof value === 'string') {
    try {
      return normalizePublishedLocales(JSON.parse(value), defaultLocale)
    } catch (error) {
      return normalizePublishedLocales(value.split(','), defaultLocale)
    }
  }
  return normalizePublishedLocales([], defaultLocale)
}

export function hasRequiredLocalizedFields(source, locale, baseFields) {
  return baseFields.every(baseField => String(getLocalizedValue(source, baseField, locale) || '').trim())
}
